import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackClickedCreateInviteLink = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedCreateInviteLink = useCallback(() => {
    track(`Clicked create invite link`);
  }, [track]);

  return { trackClickedCreateInviteLink };
};
